import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'app-message-snackbar',
    template: `<span>{{data.message}}</span>`,
    styleUrls: ['./message-snackbar.component.scss'],
    host: { '(mousedown)': 'dismiss()' },
    standalone: false
})
export class MessageSnackbarComponent implements OnInit {
	constructor(
		public snackbarRef: MatSnackBarRef<MessageSnackbarComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public data
	) {

	}

	ngOnInit(): void {
	}

	dismiss() {
		this.snackbarRef.dismiss(); //access preClose function when you want to close snackbar
	}


}
